import React, { Component, Fragment } from 'react';
import { Modal } from 'reactstrap';
class ImageDetailsModal extends Component {

    constructor(props) {
        super(props);
            this.state = {
            modal: false,
        };
    }
    
    toggleModal = () => {
        this.setState({
          modal: !this.state.modal,
        });
    }

    render () {
 
        return (
            <Fragment>
                {/* {
                    this.state.modal && (
                        <i 
                            className="fa fa-times text-white pointer font-4xl" 
                            onClick={this.toggleModal}
                            style={{ position: 'absolute', top: '-10%', right: '10%', zIndex: 9999 }} 
                        />
                    )
                } */}
                <Modal 
                    isOpen={this.state.modal}
                    toggle={this.toggleModal}
                    modalClassName="custom-modal-container"
                    contentClassName="custom-modal-content"
                    className={ this.props.className ? `${this.props.className} custom-modal-body` : "custom-modal-body" }
                    style={this.props.style ? this.props.style : {}}
                >
                    
                    <img
                        ref={`image-details`}
                        onError={() => this.refs[`image-details`].src = 'https://dondemand-dev.sfo3.cdn.digitaloceanspaces.com/static/default/avatar_admin.png' }
                        className="custom-modal-image"
                        src={ this.props.image }
                        alt={ 'chat-image' }
                        onClick={this.toggleModal}
                    />
                    {this.props.title && (
                        <span className="text-white mt-2 text-center font-2xl">{this.props.title}</span>
                    )}
                </Modal>
            </Fragment>
        )
    }
}

export default ImageDetailsModal



// WEBPACK FOOTER //
// ./src/views/Plugins/MainModals/ImageDetailsModal.jsx